import type { ImeiHubServiceId } from '@redevicer/shared'
import type { ImeiCheckPayload } from './imeiReportModel'

export type ImeiHubPreviewSample = {
  data: ImeiCheckPayload
  imeiMasked: string
  checkedAt: string
}

function sample(
  imeiMasked: string,
  checkedAt: string,
  payload: ImeiCheckPayload,
): ImeiHubPreviewSample {
  return { imeiMasked, checkedAt, data: payload }
}

const PREVIEW_BY_SERVICE: Record<ImeiHubServiceId, ImeiHubPreviewSample> = {
  verify: sample('356789******123', '2026-01-15T12:00:00.000Z', {
    is_valid: true,
    is_stolen: false,
    is_blacklisted: false,
    is_financed: false,
    icloud_locked: false,
    brand: 'Apple',
    model: 'iPhone 14',
    carrier: 'Tele2',
    message: null,
    device: { color: 'Midnight', release_year: 2022, tac: '35678901', provider: 'stub' },
  }),
  passport: sample('352099******456', '2026-02-03T09:30:00.000Z', {
    is_valid: true,
    is_stolen: false,
    is_blacklisted: false,
    is_financed: false,
    icloud_locked: false,
    brand: 'Apple',
    model: 'iPhone 13 Pro',
    carrier: 'Telia',
    message: null,
    device: { color: 'Sierra Blue', release_year: 2021, tac: '35209941', provider: 'stub' },
  }),
  lock: sample('359488******789', '2026-02-18T16:45:00.000Z', {
    is_valid: true,
    is_stolen: false,
    is_blacklisted: false,
    is_financed: false,
    icloud_locked: false,
    brand: 'Apple',
    model: 'iPhone 15',
    carrier: 'Bitė',
    message: null,
    device: { color: 'Blue', release_year: 2023, tac: '35948812', provider: 'stub' },
  }),
  carrier: sample('353915******012', '2025-12-08T11:15:00.000Z', {
    is_valid: true,
    is_stolen: false,
    is_blacklisted: false,
    is_financed: false,
    icloud_locked: false,
    brand: 'Apple',
    model: 'iPhone 12',
    carrier: 'Tele2',
    message: null,
    device: { color: 'White', release_year: 2020, tac: '35391509', provider: 'stub' },
  }),
  safecheck: sample('352609******334', '2026-03-01T08:00:00.000Z', {
    is_valid: true,
    is_stolen: false,
    is_blacklisted: false,
    is_financed: false,
    icloud_locked: false,
    brand: 'Samsung',
    model: 'Galaxy A54',
    carrier: 'Tele2',
    message: null,
    device: { color: 'Awesome Violet', release_year: 2023, tac: '35260978', provider: 'stub' },
  }),
  business: sample('356789******567', '2026-01-28T14:20:00.000Z', {
    is_valid: true,
    is_stolen: false,
    is_blacklisted: false,
    is_financed: false,
    icloud_locked: false,
    brand: 'Apple',
    model: 'iPhone 14 Pro',
    carrier: 'Telia',
    message: null,
    device: { color: 'Deep Purple', release_year: 2022, tac: '35678914', provider: 'stub' },
  }),
  android: sample('351623******890', '2026-02-11T10:05:00.000Z', {
    is_valid: true,
    is_stolen: false,
    is_blacklisted: false,
    is_financed: false,
    icloud_locked: false,
    brand: 'Samsung',
    model: 'Galaxy S23',
    carrier: 'Bitė',
    message: null,
    device: { color: 'Phantom Black', release_year: 2023, tac: '35162389', provider: 'stub' },
  }),
  gsx: sample('353911******221', '2026-03-10T13:40:00.000Z', {
    is_valid: true,
    is_stolen: false,
    is_blacklisted: false,
    is_financed: false,
    icloud_locked: false,
    brand: 'Apple',
    model: 'iPhone 15 Pro Max',
    carrier: 'Unlocked',
    message: null,
    device: { color: 'Natural Titanium', release_year: 2023, tac: '35391108', provider: 'stub' },
  }),
  tmobile: sample('352099******884', '2026-03-12T09:15:00.000Z', {
    is_valid: true,
    is_stolen: false,
    is_blacklisted: false,
    is_financed: false,
    icloud_locked: false,
    brand: 'Apple',
    model: 'iPhone 14',
    carrier: 'T-Mobile',
    message: null,
    device: { color: 'Starlight', release_year: 2022, tac: '35209944', provider: 'stub' },
  }),
}

/** Sample report card for hub service docs (device, IMEI, date vary per service). */
export function imeiHubPreviewSample(service: ImeiHubServiceId): ImeiHubPreviewSample {
  return PREVIEW_BY_SERVICE[service]
}

/** @deprecated Use {@link imeiHubPreviewSample} */
export function imeiHubPreviewPayload(service: ImeiHubServiceId): ImeiCheckPayload {
  return imeiHubPreviewSample(service).data
}

/** @deprecated Use {@link imeiHubPreviewSample} */
export const IMEI_HUB_PREVIEW_MASKED = PREVIEW_BY_SERVICE.verify.imeiMasked
